import { Box, Typography } from '@mui/material';
import React from 'react';
import RouteLink from 'components/common/route-link/RouteLink';
import SourceTypeIcon, { SourceType } from 'components/common/source-type-icon/SourceTypeIcon';

interface SourceNameCellProps {
    text?: string;
    href?: string;
    sourceType: SourceType;
    dataTestCell?: string;
}

/**
 * Name cell for a Knowledge Graph model or domain: the standard source/BI-tool logo followed by
 * the name, linked to the Knowledge Graph editor only when the caller supplies an href (the user
 * has access to that model or domain).
 */
export default function SourceNameCell({ text, href, sourceType, dataTestCell }: SourceNameCellProps) {
    const name = (
        <Box component={'span'} sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {text}
        </Box>
    );

    return (
        <Typography noWrap sx={{ display: 'inline-flex', alignItems: 'center', gap: 1.5, maxWidth: '100%' }}>
            <SourceTypeIcon sourceType={sourceType} size={14} />
            {href ? (
                <Box
                    component={RouteLink}
                    to={href}
                    data-test={dataTestCell}
                    sx={{ display: 'inline-flex', alignItems: 'center', maxWidth: '100%' }}
                >
                    {name}
                </Box>
            ) : (
                name
            )}
        </Typography>
    );
}
